import { render, staticRenderFns } from "./WaitingForMoney.vue?vue&type=template&id=46c69fbc&scoped=true"
import script from "./WaitingForMoney.vue?vue&type=script&lang=js"
export * from "./WaitingForMoney.vue?vue&type=script&lang=js"
import style0 from "./WaitingForMoney.vue?vue&type=style&index=0&id=46c69fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c69fbc",
  null
  
)

export default component.exports